import React from 'react'
import { StyledIcon } from '../StyledIcon'

const style = {
  gold: {
    display: 'none',
  },
  polygon: {
    display: 'inline',
    fill: '#2E4787',
  },
  polygon2: {
    display: 'inline',
    fill: '#FFCE05',
  },
  inline: {
    display: 'inline',
  },
}

const CarpartsBlogIcon = ({ icon, size, customProps }) => (
  <StyledIcon
    viewBox="0 0 949.4 188"
    a11yTitle={icon}
    color="plain"
    size={size}
    {...customProps}
  >
    <g id="orange">
      <polygon
        fill="#2E4787"
        points="915.2,181.8 384,181.8 414.9,6.2 946.1,6.2"
      />
      <g>
        <g>
          <path fill="#2E4787" d="M33,6.2h27.2L39.3,124.7H12.1L33,6.2z" />
          <path
            fill="#2E4787"
            d="M96.7,32.3h-0.3l-14.6,92.3h-25L77.5,6.2h39.6l3.7,92.3l0.4-0.3l14.3-92h25.2l-20.9,118.5h-39.6L96.7,32.3z"
          />
          <path
            fill="#2E4787"
            d="M203,27.4h-19l3.8-21.3h65.2l-3.8,21.3h-19L213,124.7h-27.2L203,27.4z"
          />
          <path
            fill="#2E4787"
            d="M260.9,6.2h27.2l-8.2,46.3h15.7l8.2-46.3H331l-20.9,118.5h-27.2l9-50.9h-15.7l-9,50.9H240L260.9,6.2z"
          />
          <path
            fill="#2E4787"
            d="M345.7,6.2h52.2l-3.8,21.3h-25l-4.6,26h23.2l-3.6,20.3H361l-5.2,29.6h27l-3.8,21.3h-54.2L345.7,6.2z"
          />
        </g>
      </g>
      <g>
        <path
          fill="#FFFFFF"
          d="M433.9,54.3c0.9-5.1,2.5-9.3,4.7-12.7c2.2-3.4,5.1-6,8.6-8c3.5-2,7.7-3.3,12.4-4.1c4.8-0.8,10.1-1.1,16.2-1.1
  c5.7,0,10.8,0.3,15.3,1c4.5,0.7,8.2,2.1,11.1,4.2c2.9,2.1,4.8,5.1,5.9,8.9c1.1,3.9,1,9.1-0.1,15.5l-2.2,12.3h-27.8l2.3-13.2
  c0.5-2.9,0.2-4.8-0.9-5.8c-1.1-1-3.5-1.5-7.2-1.5c-2.8,0-4.8,0.5-6.2,1.6c-1.3,1-2.3,3.1-2.8,6.2l-12.9,72.9
  c-0.3,1.6,0.1,2.8,1.1,3.6c1,0.8,3,1.1,5.9,1.1c3.6,0,6.1-0.4,7.5-1.1c1.4-0.8,2.2-1.8,2.4-3l3.5-19.8h-8.8l4.2-23.6h36.6
  l-7.1,40.4c-1.1,6.1-2.6,11-4.5,14.8c-1.9,3.7-4.5,6.6-7.9,8.7c-3.3,2.1-7.4,3.5-12.3,4.2c-4.9,0.7-10.8,1-17.7,1
  c-6,0-11.3-0.4-15.8-1.1c-4.5-0.8-8.2-2.1-11-4.1c-2.8-2-4.8-4.6-5.8-8c-1-3.4-1.1-7.6-0.2-12.7L433.9,54.3z"
        />
        <path
          fill="#FFFFFF"
          d="M535.3,29.8h46.9L579,155.5h-29.3l1.7-30.2h-18.7l-9,30.2h-29.3L535.3,29.8z M555.9,47.2h-0.3l-16.7,56.6
  h13.9L555.9,47.2z"
        />
        <path
          fill="#FFFFFF"
          d="M606.5,29.8h35.6c7.8,0,14.1,0.5,19,1.4c4.9,0.9,8.7,2.5,11.3,4.8c2.6,2.3,4.2,5.3,4.7,9.2
  c0.5,3.9,0.3,8.8-0.8,14.7L673.7,75c-0.8,4.7-2,8.6-3.5,11.7c-1.5,3.1-3.2,5.5-5.2,7.4c-2,1.9-4.3,3.3-6.9,4.3
  c-2.6,1-5.5,1.7-8.5,2.2l-0.1,0.3c3.1,0.7,5.8,1.4,8.1,2.2c2.3,0.8,4.1,1.9,5.5,3.3c1.4,1.4,2.3,3.4,2.7,5.7
  c0.4,2.4,0.3,5.5-0.3,9.3l-6,34.2h-28.8l6.3-35.9c0.5-2.7-0.1-4.6-1.7-5.7c-1.6-1.2-4.8-1.7-9.7-1.7h-4.9l-7.7,43.4h-28.8
  L606.5,29.8z M624.6,90.6h5.6c5.1,0,8.5-0.8,10.2-2.4c1.7-1.6,3-4.5,3.7-8.5l3.3-18.9c0.6-3.2,0.3-5.6-0.8-7.1
  c-1.1-1.5-3.2-2.3-6.4-2.3h-8.7L624.6,90.6z"
        />
        <path
          fill="#FFFFFF"
          d="M705.1,29.8h46.9l-3.2,125.6h-29.3l1.7-30.2h-18.7l-9,30.2H664L705.1,29.8z M725.6,47.2h-0.3l-16.7,56.6h13.9
  L725.6,47.2z"
        />
        <path
          fill="#FFFFFF"
          d="M770.1,54.3c0.9-5.1,2.5-9.3,4.7-12.7c2.2-3.4,5.1-6,8.6-8c3.5-2,7.7-3.3,12.4-4.1c4.8-0.8,10.1-1.1,16.2-1.1
  c5.7,0,10.8,0.3,15.3,1c4.5,0.7,8.2,2.1,11.1,4.2c2.9,2.1,4.8,5.1,5.9,8.9c1.1,3.9,1,9.1-0.1,15.5l-2.2,12.3h-27.8l2.3-13.2
  c0.5-2.9,0.2-4.8-0.9-5.8c-1.1-1-3.5-1.5-7.2-1.5c-2.8,0-4.8,0.5-6.2,1.6c-1.3,1-2.3,3.1-2.8,6.2l-12.9,72.9
  c-0.3,1.6,0.1,2.8,1.1,3.6c1,0.8,3,1.1,5.9,1.1c3.6,0,6.1-0.4,7.5-1.1c1.4-0.8,2.2-1.8,2.4-3l3.5-19.8h-8.8l4.2-23.6h36.6
  l-7.1,40.4c-1.1,6.1-2.6,11-4.5,14.8c-1.9,3.7-4.5,6.6-7.9,8.7c-3.3,2.1-7.4,3.5-12.3,4.2c-4.9,0.7-10.8,1-17.7,1
  c-6,0-11.3-0.4-15.8-1.1c-4.5-0.8-8.2-2.1-11-4.1c-2.8-2-4.8-4.6-5.8-8c-1-3.4-1.1-7.6-0.2-12.7L770.1,54.3z"
        />
        <path
          fill="#FFFFFF"
          d="M856,29.8h55.4l-4,22.6h-26.5L876,80h24.6l-3.8,21.5h-24.6l-5.5,31.4h28.6l-4,22.6h-57.4L856,29.8z"
        />
      </g>
      <polygon
        fill="#FC7E00"
        points="369.2,181.7 3.3,181.7 10.6,139.9 376.6,139.9"
      />
    </g>
    <g id="gold" style={style.gold}>
      <polygon
        style={style.polygon}
        points="915.2,181.8 384,181.8 414.9,6.2 946.1,6.2"
      />
      <g style={style.inline}>
        <g>
          <path fill="#2E4787" d="M33,6.2h27.2L39.3,124.7H12.1L33,6.2z" />
          <path
            fill="#2E4787"
            d="M96.7,32.3h-0.3l-14.6,92.3h-25L77.5,6.2h39.6l3.7,92.3l0.4-0.3l14.3-92h25.2l-20.9,118.5h-39.6L96.7,32.3z"
          />
          <path
            fill="#2E4787"
            d="M203,27.4h-19l3.8-21.3h65.2l-3.8,21.3h-19L213,124.7h-27.2L203,27.4z"
          />
          <path
            fill="#2E4787"
            d="M260.9,6.2h27.2l-8.2,46.3h15.7l8.2-46.3H331l-20.9,118.5h-27.2l9-50.9h-15.7l-9,50.9H240L260.9,6.2z"
          />
          <path
            fill="#2E4787"
            d="M345.7,6.2h52.2l-3.8,21.3h-25l-4.6,26h23.2l-3.6,20.3H361l-5.2,29.6h27l-3.8,21.3h-54.2L345.7,6.2z"
          />
        </g>
      </g>
      <g style={style.inline}>
        <path
          fill="#FFFFFF"
          d="M433.9,54.3c0.9-5.1,2.5-9.3,4.7-12.7c2.2-3.4,5.1-6,8.6-8c3.5-2,7.7-3.3,12.4-4.1c4.8-0.8,10.1-1.1,16.2-1.1
  c5.7,0,10.8,0.3,15.3,1c4.5,0.7,8.2,2.1,11.1,4.2c2.9,2.1,4.8,5.1,5.9,8.9c1.1,3.9,1,9.1-0.1,15.5l-2.2,12.3h-27.8l2.3-13.2
  c0.5-2.9,0.2-4.8-0.9-5.8c-1.1-1-3.5-1.5-7.2-1.5c-2.8,0-4.8,0.5-6.2,1.6c-1.3,1-2.3,3.1-2.8,6.2l-12.9,72.9
  c-0.3,1.6,0.1,2.8,1.1,3.6c1,0.8,3,1.1,5.9,1.1c3.6,0,6.1-0.4,7.5-1.1c1.4-0.8,2.2-1.8,2.4-3l3.5-19.8h-8.8l4.2-23.6h36.6
  l-7.1,40.4c-1.1,6.1-2.6,11-4.5,14.8c-1.9,3.7-4.5,6.6-7.9,8.7c-3.3,2.1-7.4,3.5-12.3,4.2c-4.9,0.7-10.8,1-17.7,1
  c-6,0-11.3-0.4-15.8-1.1c-4.5-0.8-8.2-2.1-11-4.1c-2.8-2-4.8-4.6-5.8-8c-1-3.4-1.1-7.6-0.2-12.7L433.9,54.3z"
        />
        <path
          fill="#FFFFFF"
          d="M535.3,29.8h46.9L579,155.5h-29.3l1.7-30.2h-18.7l-9,30.2h-29.3L535.3,29.8z M555.9,47.2h-0.3l-16.7,56.6
  h13.9L555.9,47.2z"
        />
        <path
          fill="#FFFFFF"
          d="M606.5,29.8h35.6c7.8,0,14.1,0.5,19,1.4c4.9,0.9,8.7,2.5,11.3,4.8c2.6,2.3,4.2,5.3,4.7,9.2
  c0.5,3.9,0.3,8.8-0.8,14.7L673.7,75c-0.8,4.7-2,8.6-3.5,11.7c-1.5,3.1-3.2,5.5-5.2,7.4c-2,1.9-4.3,3.3-6.9,4.3
  c-2.6,1-5.5,1.7-8.5,2.2l-0.1,0.3c3.1,0.7,5.8,1.4,8.1,2.2c2.3,0.8,4.1,1.9,5.5,3.3c1.4,1.4,2.3,3.4,2.7,5.7
  c0.4,2.4,0.3,5.5-0.3,9.3l-6,34.2h-28.8l6.3-35.9c0.5-2.7-0.1-4.6-1.7-5.7c-1.6-1.2-4.8-1.7-9.7-1.7h-4.9l-7.7,43.4h-28.8
  L606.5,29.8z M624.6,90.6h5.6c5.1,0,8.5-0.8,10.2-2.4c1.7-1.6,3-4.5,3.7-8.5l3.3-18.9c0.6-3.2,0.3-5.6-0.8-7.1
  c-1.1-1.5-3.2-2.3-6.4-2.3h-8.7L624.6,90.6z"
        />
        <path
          fill="#FFFFFF"
          d="M705.1,29.8h46.9l-3.2,125.6h-29.3l1.7-30.2h-18.7l-9,30.2H664L705.1,29.8z M725.6,47.2h-0.3l-16.7,56.6h13.9
  L725.6,47.2z"
        />
        <path
          fill="#FFFFFF"
          d="M770.1,54.3c0.9-5.1,2.5-9.3,4.7-12.7c2.2-3.4,5.1-6,8.6-8c3.5-2,7.7-3.3,12.4-4.1c4.8-0.8,10.1-1.1,16.2-1.1
  c5.7,0,10.8,0.3,15.3,1c4.5,0.7,8.2,2.1,11.1,4.2c2.9,2.1,4.8,5.1,5.9,8.9c1.1,3.9,1,9.1-0.1,15.5l-2.2,12.3h-27.8l2.3-13.2
  c0.5-2.9,0.2-4.8-0.9-5.8c-1.1-1-3.5-1.5-7.2-1.5c-2.8,0-4.8,0.5-6.2,1.6c-1.3,1-2.3,3.1-2.8,6.2l-12.9,72.9
  c-0.3,1.6,0.1,2.8,1.1,3.6c1,0.8,3,1.1,5.9,1.1c3.6,0,6.1-0.4,7.5-1.1c1.4-0.8,2.2-1.8,2.4-3l3.5-19.8h-8.8l4.2-23.6h36.6
  l-7.1,40.4c-1.1,6.1-2.6,11-4.5,14.8c-1.9,3.7-4.5,6.6-7.9,8.7c-3.3,2.1-7.4,3.5-12.3,4.2c-4.9,0.7-10.8,1-17.7,1
  c-6,0-11.3-0.4-15.8-1.1c-4.5-0.8-8.2-2.1-11-4.1c-2.8-2-4.8-4.6-5.8-8c-1-3.4-1.1-7.6-0.2-12.7L770.1,54.3z"
        />
        <path
          fill="#FFFFFF"
          d="M856,29.8h55.4l-4,22.6h-26.5L876,80h24.6l-3.8,21.5h-24.6l-5.5,31.4h28.6l-4,22.6h-57.4L856,29.8z"
        />
      </g>
      <polygon
        style={style.ploygon2}
        points="369.2,181.7 3.3,181.7 10.6,139.9 376.6,139.9"
      />
      <g style={style.inline}>
        <g>
          <path
            d="M45.5,171.5c-0.2,0-0.3-0.1-0.4-0.3l-1.4-13.3h-0.1l-6.1,13.3c-0.1,0.2-0.2,0.3-0.5,0.3H34
    c-0.2,0-0.3-0.1-0.3-0.3l-1.9-20.8c0-0.2,0.1-0.3,0.3-0.3h4.1c0.2,0,0.3,0.1,0.3,0.3l0.7,13.5h0.1l6-13.5
    c0.1-0.2,0.2-0.3,0.5-0.3h2.7c0.2,0,0.3,0.1,0.3,0.3l1.4,13.5h0.1l5.3-13.5c0.1-0.2,0.2-0.3,0.4-0.3h4c0.2,0,0.3,0.1,0.2,0.3
    l-9.2,20.8c-0.1,0.2-0.2,0.3-0.5,0.3H45.5z"
          />
          <path
            d="M61.4,150.4c0-0.2,0.2-0.3,0.4-0.3h4c0.2,0,0.3,0.1,0.3,0.3l-3.7,20.8c0,0.2-0.2,0.3-0.4,0.3h-4
    c-0.2,0-0.3-0.1-0.3-0.3L61.4,150.4z"
          />
          <path
            d="M71.7,171.5c-0.2,0-0.3-0.1-0.3-0.3l3-16.8c0-0.1,0-0.2-0.2-0.2h-5.4c-0.2,0-0.3-0.1-0.3-0.3l0.6-3.5
    c0-0.2,0.2-0.3,0.4-0.3h15.9c0.2,0,0.3,0.1,0.3,0.3l-0.6,3.5c0,0.2-0.2,0.3-0.4,0.3h-5.4c-0.1,0-0.2,0.1-0.2,0.2l-3,16.8
    c0,0.2-0.2,0.3-0.4,0.3H71.7z"
          />
          <path
            d="M88.9,150.4c0-0.2,0.2-0.3,0.4-0.3h4c0.2,0,0.3,0.1,0.3,0.3l-1.4,8c0,0.1,0,0.2,0.2,0.2h7
    c0.1,0,0.2-0.1,0.2-0.2l1.4-8c0-0.2,0.2-0.3,0.4-0.3h4c0.2,0,0.3,0.1,0.3,0.3l-3.7,20.8c0,0.2-0.2,0.3-0.4,0.3h-4
    c-0.2,0-0.3-0.1-0.3-0.3l1.5-8.3c0-0.1,0-0.2-0.2-0.2h-7c-0.1,0-0.2,0.1-0.2,0.2l-1.5,8.3c0,0.2-0.2,0.3-0.4,0.3h-4
    c-0.2,0-0.3-0.1-0.3-0.3L88.9,150.4z"
          />
          <path
            d="M116,160.8c0.6-3.3,0.9-4.4,1.6-5.8c1.8-3.5,4.8-5.3,8.6-5.3c3.6,0,6,1.8,6.6,4.8c0.1,0.2,0,0.3-0.2,0.4
    l-3.7,1.5c-0.2,0.1-0.4,0-0.4-0.2c-0.4-1.4-1.2-2.4-3-2.4c-1.7,0-2.9,0.9-3.6,2.4c-0.4,0.8-0.6,1.5-1.2,4.6
    c-0.5,3.1-0.6,3.8-0.5,4.6c0.2,1.5,1.1,2.4,2.8,2.4c1.8,0,3-1,3.8-2.4c0.1-0.2,0.3-0.3,0.5-0.2l3.2,1.5c0.2,0.1,0.2,0.2,0.1,0.4
    c-1.7,3-4.7,4.8-8.3,4.8c-3.8,0-6.2-1.8-6.7-5.3C115.3,165.2,115.4,164.1,116,160.8z"
          />
          <path
            d="M142.9,150.4c0.1-0.2,0.2-0.3,0.5-0.3h4c0.2,0,0.3,0.1,0.4,0.3l3.6,20.8c0,0.2-0.1,0.3-0.3,0.3h-4.1
    c-0.2,0-0.3-0.1-0.4-0.3l-0.6-3.8h-7.5l-1.9,3.8c-0.1,0.2-0.2,0.3-0.5,0.3H132c-0.2,0-0.3-0.1-0.2-0.3L142.9,150.4z M145.4,163.5
    l-1.1-7.5h-0.1l-3.8,7.5H145.4z"
          />
          <path
            d="M166.2,171.5c-0.3,0-0.4-0.1-0.4-0.3l-2.3-7.8h-2.9c-0.1,0-0.2,0.1-0.2,0.2l-1.4,7.7c0,0.2-0.2,0.3-0.4,0.3
    h-4c-0.2,0-0.3-0.1-0.3-0.3l3.7-20.8c0-0.2,0.2-0.3,0.4-0.3h8.5c4.4,0,6.8,2.7,6.1,6.7c-0.5,2.7-2.3,4.9-4.9,6l2.7,8.5
    c0.1,0.2-0.1,0.4-0.3,0.4H166.2z M168.5,156.7c0.3-1.6-0.7-2.6-2.4-2.6h-3.8c-0.1,0-0.2,0.1-0.2,0.2l-0.9,4.9
    c0,0.1,0,0.2,0.2,0.2h3.8C166.9,159.4,168.2,158.3,168.5,156.7z"
          />
          <path
            d="M175,171.5c-0.2,0-0.3-0.1-0.3-0.3l3.7-20.8c0-0.2,0.2-0.3,0.4-0.3h8.3c4.7,0,7,2.8,6.3,6.9
    c-0.7,4-4.1,6.9-8.7,6.9h-3.8c-0.1,0-0.2,0.1-0.2,0.2l-1.3,7.2c0,0.2-0.2,0.3-0.4,0.3H175z M188.7,157c0.3-1.7-0.7-2.9-2.6-2.9
    h-3.5c-0.1,0-0.2,0.1-0.2,0.2l-1,5.4c0,0.1,0,0.2,0.2,0.2h3.5C187,159.8,188.4,158.7,188.7,157z"
          />
          <path
            d="M201.7,150.4c0.1-0.2,0.2-0.3,0.5-0.3h4c0.2,0,0.3,0.1,0.4,0.3l3.6,20.8c0,0.2-0.1,0.3-0.3,0.3h-4.1
    c-0.2,0-0.3-0.1-0.4-0.3l-0.6-3.8h-7.5l-1.9,3.8c-0.1,0.2-0.2,0.3-0.5,0.3h-4.1c-0.2,0-0.3-0.1-0.2-0.3L201.7,150.4z
     M204.2,163.5l-1.1-7.5H203l-3.8,7.5H204.2z"
          />
          <path
            d="M225,171.5c-0.3,0-0.4-0.1-0.4-0.3l-2.3-7.8h-2.9c-0.1,0-0.2,0.1-0.2,0.2l-1.4,7.7c0,0.2-0.2,0.3-0.4,0.3h-4
    c-0.2,0-0.3-0.1-0.3-0.3l3.7-20.8c0-0.2,0.2-0.3,0.4-0.3h8.5c4.4,0,6.8,2.7,6.1,6.7c-0.5,2.7-2.3,4.9-4.9,6l2.7,8.5
    c0.1,0.2-0.1,0.4-0.3,0.4H225z M227.3,156.7c0.3-1.6-0.7-2.6-2.4-2.6h-3.8c-0.1,0-0.2,0.1-0.2,0.2l-0.9,4.9c0,0.1,0,0.2,0.2,0.2
    h3.8C225.7,159.4,227,158.3,227.3,156.7z"
          />
          <path
            d="M238.1,171.5c-0.2,0-0.3-0.1-0.3-0.3l3-16.8c0-0.1,0-0.2-0.2-0.2h-5.4c-0.2,0-0.3-0.1-0.3-0.3l0.6-3.5
    c0-0.2,0.2-0.3,0.4-0.3h15.9c0.2,0,0.3,0.1,0.3,0.3l-0.6,3.5c0,0.2-0.2,0.3-0.4,0.3h-5.4c-0.1,0-0.2,0.1-0.2,0.2l-3,16.8
    c0,0.2-0.2,0.3-0.4,0.3H238.1z"
          />
          <path
            d="M251,168.9c-0.1-0.1-0.1-0.3,0.1-0.5l2.9-2.7c0.2-0.2,0.3-0.2,0.5,0c1.2,1.1,3,2.2,5.2,2.2
    c2.2,0,3.7-1,4-2.6c0.2-1.3-0.4-2-2.9-2.4l-1.1-0.2c-4.2-0.6-6.3-2.6-5.6-6.4c0.7-3.9,4.1-6.6,8.8-6.6c2.8,0,5.3,0.9,6.9,2.2
    c0.2,0.1,0.2,0.3,0,0.5l-2.4,2.9c-0.2,0.2-0.3,0.2-0.5,0.1c-1.5-1.1-2.9-1.6-4.7-1.6c-1.9,0-3,1-3.3,2.3c-0.2,1.2,0.5,2,2.9,2.4
    l1.1,0.2c4.3,0.6,6.3,2.6,5.6,6.5c-0.7,3.9-4.1,6.7-9.6,6.7C255.4,171.8,252.4,170.5,251,168.9z"
          />
          <path
            d="M271.6,167.4c0-0.2,0.2-0.3,0.4-0.3h3.8c0.2,0,0.3,0.1,0.3,0.3l-0.7,3.8c0,0.2-0.2,0.3-0.4,0.3h-3.8
    c-0.2,0-0.3-0.1-0.3-0.3L271.6,167.4z"
          />
          <path
            d="M281.1,160.8c0.6-3.3,0.9-4.4,1.6-5.8c1.8-3.5,4.8-5.3,8.6-5.3c3.6,0,6,1.8,6.6,4.8c0.1,0.2,0,0.3-0.2,0.4
    l-3.7,1.5c-0.2,0.1-0.4,0-0.4-0.2c-0.4-1.4-1.2-2.4-3-2.4c-1.7,0-2.9,0.9-3.6,2.4c-0.4,0.8-0.6,1.5-1.2,4.6
    c-0.5,3.1-0.6,3.8-0.5,4.6c0.2,1.5,1.1,2.4,2.8,2.4c1.8,0,3-1,3.8-2.4c0.1-0.2,0.3-0.3,0.5-0.2l3.2,1.5c0.2,0.1,0.2,0.2,0.1,0.4
    c-1.7,3-4.7,4.8-8.3,4.8c-3.8,0-6.2-1.8-6.7-5.3C280.5,165.2,280.5,164.1,281.1,160.8z"
          />
          <path
            d="M299.4,166.6c-0.2-1.5-0.1-2.7,0.4-5.9c0.6-3.2,0.9-4.4,1.6-5.9c1.7-3.5,5-5.2,8.7-5.2
    c3.8,0,6.4,1.7,6.9,5.2c0.2,1.5,0.1,2.7-0.4,5.9c-0.6,3.2-0.9,4.4-1.6,5.9c-1.7,3.5-5,5.2-8.7,5.2
    C302.6,171.8,299.9,170.1,299.4,166.6z M310.9,165.4c0.4-0.8,0.7-1.8,1.2-4.6c0.5-2.8,0.6-3.8,0.5-4.6c-0.2-1.5-1.2-2.4-3-2.4
    c-1.8,0-3.1,0.9-3.8,2.4c-0.4,0.8-0.7,1.8-1.2,4.6c-0.5,2.8-0.6,3.8-0.5,4.6c0.2,1.5,1.2,2.4,3,2.4
    C308.8,167.7,310.1,166.9,310.9,165.4z"
          />
          <path
            d="M322.7,150.4c0-0.2,0.2-0.3,0.4-0.3h3.8c0.3,0,0.4,0.1,0.4,0.3l3.3,12.2h0.1l7.5-12.2
    c0.1-0.2,0.3-0.3,0.6-0.3h3.7c0.2,0,0.3,0.1,0.3,0.3l-3.7,20.8c0,0.2-0.2,0.3-0.4,0.3h-3.6c-0.2,0-0.3-0.1-0.3-0.3l2.1-12.1h-0.1
    l-5.6,9c-0.2,0.3-0.4,0.4-0.7,0.4h-2.2c-0.3,0-0.5-0.1-0.5-0.4l-2.4-9h-0.1l-2.1,12.1c0,0.2-0.2,0.3-0.4,0.3h-3.6
    c-0.2,0-0.3-0.1-0.3-0.3L322.7,150.4z"
          />
        </g>
      </g>
    </g>
  </StyledIcon>
)

export default CarpartsBlogIcon
